var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.surgery && _vm.documents)?_c('surg-approve',{attrs:{"surgery":_vm.surgery,"files":_vm.documents,"patientRequests":_vm.patientRequests,"isInfo":true},on:{"approveGoBack":function($event){return _vm.$router.go(-1)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }